export const LINK_PAYMENT_STATUS_GET ="/LinkPaymentStatus/GetAllLinkPaymentStatus"
